import { theme as baseTheme } from "@chakra-ui/react";

export const FormLabel = {
  baseStyle: {
    color: 'brand.500'
  },
  sizes: {
    sm: {
      fontSize: 'sm',
    }
  }
};

export const Textarea = {
  baseStyle: {
    boxShadow: 'none !important',
  },
}

export const Select = {
  variants: {
    primary: {
      field: {
        height: '38px',
        borderRadius: '4px',
        borderColor: '#e2e3e7',
        borderWidth: 1,
        fontWeight: 500,
        color: '#06BCC1'
      },
      icon: {
        color: '#110000',
      }
    }
  },
  sizes: {
    sm: {
      field: {
        minWidth: '140px',
        fontSize: baseTheme.fontSizes.sm,
      }
    }
  }
};

export const Input = {
  baseStyle: {
    field: {
      bg: '#ffffff',
      borderColor: '#e2e3e7',
      borderWidth: 1,
      ':focus': {
        borderColor: 'brand.500',
      },
      ':hover': {
        borderColor: 'brand.500',
      },
      ':active': {
        borderColor: 'brand.500',
      },
      ':disabled': {
        opacity: 0.5,
        _hover: {
          cursor: 'not-allowed',
          borderColor: 'inherit',
        }
      },
      _invalid: {
        borderColor: 'error.500',
      }
    },
  },
  sizes: {
    sm: {
      field: {
        height: '40px',
        borderRadius: '4px',
        fontSize: baseTheme.fontSizes.sm,
      }
    },
    md: {
      field: {
        height: '50px',
        borderRadius: '4px',
        fontSize: baseTheme.fontSizes.md,
      }
    },
    lg: {
      field: {
        height: '70px',
        borderRadius: '4px',
        fontSize: baseTheme.fontSizes.lg,
      }
    }
  },
  variants: {
    readonly: {
      field: {
        color: '#918991',
        border: 'none',
      }
    },
  },
  defaultProps: {
    variant: null // null here
  }
};
